import { Moment } from "moment";

export class User {
    userId: number = 0;
    organizationId: number = 0;
    organizationName: string = "";
    username: string = "";
    userPassword: string = "";
    email: string = "";
    firstName: string = "";
    lastName: string = "";
    phoneNumber: string = "";
    cellPhoneNumber: string = "";
    isActive: boolean = true;
    imagePath: string = "";
    groupId: number = 0;
    groupName: string = "";
    idCard: string = "";
    creationDate: string = "";
    profileId: number = 0;
}

export class CreateUserRequest {
    organizationId: number = 0;
    username: string = "";
    userPassword: string = "";
    email: string = "";
    firstName: string = "";
    lastName: string = "";
    phoneNumber: string = "";
    cellPhoneNumber: string = "";
    isActive: boolean = true;
    imagePath: string = "";
    groupId: number = 0;
    idCard: string = "";
    profileId: number = 0;
}

export class FilterUsersRequest {
    keywords: string = "";
    department: string = "";
    groupId?: number | null = null;
    firstName: string = "";
    lastName: string = "";
    idCard: string = "";
    phoneNumber: string = "";
    status?: boolean | null = null;
    organizationId?: number | null = null;
    profileId?: number | null = null;
    pageIndex: number = 0;
    orderBy: string = "";
    asc: boolean = false;
    date?: Moment | null = null;
    constructor(id?: number) {
        this.organizationId = id;
    }
}

export class FilterUsersResponse {
    pageIndex: number = 0;
    totalFilter: number = 0;
    total: number = 0;
    hasNext: boolean = true;
    rows: UserRowResult[] = [];
}

export class UserRowResult {
    userId: number = 0;
    userName: string = "";
    firstName: string = "";
    lastName: string = "";
    idCard: string = "";
    phoneNumber: string = "";
    profileName: string = "";
    email: string = "";
    group: string = "";
    status: boolean = true;
    organizationName: string = "";
}
export interface GetUserProfileResponse {
    hasNext: boolean;
    rows: UserProfileItem[];
    totalFilter: number;
    total: number;
}
export class UserProfileItem {
    id: number = 0;
    createdAt: string = "";
    name: string = "";
    isActive: boolean = false;
}
export class AddProfileRequest {
    ProfileName: string = "";
    Permissions: UserPermissionStruct[] = [];
    isActive: boolean = false;
}
export class EditProfileRequest {
    Id: number = 0;
    ProfileName: string = "";
    Permissions: UserPermissionStruct[] = [];
    isActive: boolean = false;
}
export class DeleteProfileRequest {
    ProfileId: number = 0;
}
export class DeleteProfileResponse {
    id: number = 0;
}
export interface AddProfileResponse {
    id: number;
    isActive: boolean;
}
export enum PermissionType {
    View = 1,
    Edit = 2,
}
export type Dictionary<T> = { [key: string]: T };
export type Dictionary2<T> = { [key: string]: T };
export enum PermissionName {
    OrganizationDashboard = 1,
    ListOfEmployees = 2,
    CreateEmployee = 3,
    EditEmployee = 4,
    ImportEmployees = 5,
    EmployeeGeneralInfo = 6,
    EmployeeDigitalWallet = 7,
    EmployeeOrders = 8,
    EmployeeAttachedDocs = 9,
    AddAttachedDoc = 10,
    EditAttachedDoc = 11,
    ListOfWallets = 12,
    WalletBulkUpdate = 13,
    WalletTransaction = 14,
    WalletManagment = 15,
    ListOfOrders = 16,
    ListOfDocuments = 17,
    ListOfMessages = 18,
    CreateEditMessage = 19,
    ListOfForms = 20,
    CreateForms = 21,
    ManageUsers = 22,
    ManageProfiles = 23,
    InterfaceManagement = 24,
    ListOfTransactions = 25,
    LoadingNegativeWalletAmount = 26,
}
export class UserPermissionStruct {
    permissionName: PermissionName | null = null;
    permissionType: PermissionType | null = null;
}
export interface GetUserProfilePermissionsResponse {
    permissions: UserPermissionStruct[];
}
export class FilterProfilesRequest {
    Keywords: string = "";
    PageIndex: number = 0;
    OrderBy: string = "";
    Asc: boolean = true;
}
